import styled, { css } from 'styled-components';

export const Title = styled.div`
  display: flex;
  gap: 5px;
  align-items: end;

  span {
    font-weight: 900;
    color: var(--text-text02);
  }
`;

export const List = styled.div`
  ul {
    list-style-type: disc;
    list-style-sosition: outside;
    margin: 0px 48px 16px 53px;

    li {
      span {
        position: relative;
        left: -3px;
      }
    }
  }
`;

export const ChildContent = styled.div`
  padding-top: -12px;
  width: 100%;

  .discountInfo {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin: -16px 48px 16px 30px;
    font-size: 12px;

    img {
      height: 12px;
    }
  }
`;

export const SingleBank = styled.div`
  background: var(--background-background-UTP);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 4px;

  div {
    color: var(--text-text01);
    display: flex;
    align-items: end;
    font-weight: 700;
    gap: 4px;

    span {
      color: var(--text-text02);
    }
  }

  ul {
    list-style-type: disc;
    list-style-sosition: outside;
    margin: 0px 0px 0px 18px;
  }
`;

export const HorizontalLine = styled.div`
  border: none;
  border-top: 2px solid #84b1cc;
  margin: 8px 0px;
`;

export const BankButton = styled.button`
  margin-top: 16px;
  background: var(--background-background-UTP);
  color: var(--nb-primary);
  border: 1px solid var(--nb-primary);
  padding: 10px 24px 10px 16px;
  border-radius: 4px;

  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;

  span {
    display: flex;
    gap: 8px;
    align-items: normal;
  }
`;

export const BlockProntoPago = styled.div`
  display flex;
  background: var(--background-background-disabled);
  padding: 16px;
  margin: 0 0 16px 0;
  border-radius: 4px;
  align-items: center;
  gap: 8px;
`;

export const DropDownContainer = styled.div`
  justify-content: center;
  .main {
    justify-content: space-between;
    display: flex;
    margin: 16px 0px;
  }
`;

export const DropDownTitle = styled.div`
  color: var(--text-text02);
  font-weight: 900;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PeriodTitle = styled.div`
  margin: 16px 0px;
  color: var(--text-text01);
  font-weight: 700;
  font-size: 14px;
`;

export const NumberOfPayItemsCircle = styled.div`
  background: var(--button-icon-focus);
  border-radius: 100px;
  min-width: 20px;
  max-width: 34px;
  min-height: 20px;
  max-height: 20px;
  height: 20px;
  padding-right: 4px;
  padding-left: 4px;
  font-weight: 400;
  font-size: 14px;
  font-family: 'Lato';
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const PayItemCard = styled.div<{
  isFullCycleDiscount?: boolean;
  isPse?: boolean;
  isPasarela?: boolean;
}>`
  background: #fff;
  height: auto;
  border-radius: ${({ isFullCycleDiscount, isPse }) =>
    isFullCycleDiscount || isPse ? '8px 8px 0 0' : '8px'};
  // padding: 16px 0;
  color: var(--text-text02);
  font-family: Lato;
  width: 100%;
  outline: none;

  ${({ isPasarela }) =>
    !isPasarela &&
    `
    &:hover {
      background: #d5e5f0;
    }
    
    &:focus {
      background: #a8cbe2;
    }
    
    &:active {
      background: #a8cbe2;
    }
  `}

  .firstLine {
    // padding: 0 16px;
    display: flex;
    justify-content: space-between;
    font-weight: 900;
    font-size: 14px;

    span {
      display: flex;
      align-items: end;
      gap: 4px;
    }
  }

  .mora {
    color: var(--support-error);
    font-weight: 400;
    font-size: 12px;
    text-align: end;
    padding-right: 16px;
  }

  .secondLine {
    // padding: 0 16px;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 14px;
    align-items: end;
  }

  .totalDebt {
    font-weight: 700;
    font-size: 18px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;

    span {
      display: flex;
      align-items: end;
      gap: 4px;
    }
  }
`;

export const CardTotalDebt = styled.div`
  background: #fff;
  height: auto;
  border-radius: 8px;
  color: var(--text-text02);
  font-family: Lato;
  width: 100%;
  outline: none;
  padding: 8px 0px;
  height: 44px;

  .totalDebt {
    font-weight: 700;
    font-size: 18px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;

    span {
      display: flex;
      align-items: end;
      gap: 4px;
    }
  }
`;

// REGION: Card Discount Full Cycle
export const CardDiscountFullCycle = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 100%;
  outline: none;
  overflow: 'hidden';
  cursor: pointer;
  &:hover .pay-item-card {
    background-color: #d5e5f0;
  }
  &:focus .pay-item-card {
    background-color: #a8cbe2;
  }
  &:active .pay-item-card {
    background-color: #a8cbe2;
  }
`;

export const FooterPiggy = styled.div<{ isPse?: boolean }>`
  display: flex;
  height: 28px;
  background: #1a055d;
  align-items: center;
  border-radius: 0px 0px 8px 8px;
  padding: 0 16px;
  gap: 4px;
  margin-bottom: 8px;
  img {
    width: 24px;
    height: 24px;
  }

  span {
    font-weight: ${({ isPse }) => (isPse ? 400 : 900)};
    font-size: ${({ isPse }) => (isPse ? '12px' : '14px')};
    line-height: 20px;
    color: #fff;
  }
`;
// ENDREGION: Card Discount Full Cycle

export const ItemsDescription = styled.div`
  display: grid;
  gap: 4px;
`;

export const HighlightedText = styled.span`
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: #161d1f;
`;

export const FullCycleDiscountCard = styled.div<{ isMobile: boolean }>`
  background: #fff;
  display: flex;
  cursor: pointer;
  width: 100%;
  height: 126px;
  padding: ${(props) =>
    props.isMobile ? '8px 0px 8px 12px;' : '8px 32px 8px 32px'};
  border-radius: 4px;
  justify-content: center;
  margin-bottom: 16px;

  div {
    align-content: center;

    .piggyImg {
      min-width: ${(props) => (props.isMobile ? '120px' : '230px')};
      width: ${(props) => (props.isMobile ? '120px' : '230px')};
      height: ${(props) => (props.isMobile ? '118px' : '126px')};
    }

    @media (max-width: 639.5px) {
      .piggyImg {
        min-width: 100px;
        width: 100px;
        height: 118px;
      }
    }

    p {
      strong {
        font-weight: 700;
        font-size: ${(props) => (props.isMobile ? '16px' : '20px')};
      }
    }
  }

  .dataLeft {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
  }

  .dataRight {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (360px <= width <= 639.5px) {
    justify-content: space-between;
  }

  @media (640px <= width <= 767.5px) {
    .dataLeft {
      width: 298px;
    }
    .dataRight {
      width: 229px;
    }
  }

  @media (min-width: 991.5px) {
    .dataLeft {
      width: auto;
    }
    .dataRight {
      width: 210px;
    }
  }

  .purple {
    display: inline;
    font-weight: ${(props) => (props.isMobile ? '900' : '700')};
    line-height: 20px;
    align-items: center;
    flex-wrap: wrap;
    font-size: ${(props) => (props.isMobile ? '14px' : '16px')};
    color: var(--text-primary);
    gap: 4px;
  }

  .action-arrow {
    display: inline;
    vertical-align: middle;
    margin-left: 4px;
    margin-top: -2px;
    width: ${(props) => (props.isMobile ? '12px' : '16px')};
    height: ${(props) => (props.isMobile ? '12px' : '16px')};
  }

  &:hover {
    background: #d5e5f0;
  }

  &:focus {
    background: #a8cbe2;
    outline: none;
  }
`;

export const ItemsSection = styled.div`
  display: grid;
  gap: 16px;
`;
interface EmptyPaymentsProps {
  online?: boolean; // Prop opcional
}

const payOnlineStyle = css`
  display: grid;
  gap: 16px;
  padding: 40px 0;

  .emptyInfo {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
const emptyStyle = css`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const EmptyPayments = styled.div<EmptyPaymentsProps>`
  line-height: 20px;
  margin: 16px 0;

  img {
    width: 80px;
    height: 80px;
  }

  ${(props) => (props.online ? payOnlineStyle : emptyStyle)}
`;

export const PaymentsSection = styled.div`
  display: grid;
  gap: 16px;
`;
